// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loginPage:before{content:\"\";position:fixed;width:100vw;height:100vh;background-image:url(/static/img/login-bg.jpg);background-position:50%;background-repeat:no-repeat;background-attachment:fixed;background-size:cover;-moz-filter:blur(2px);-o-filter:blur(2px);-ms-filter:blur(2px);filter:blur(2px)}", ""]);
// Exports
module.exports = exports;
